import config from 'config'
import { getJsonHeaders } from './helpers'

export async function listAll() {
  const result = await fetch(config.API_URL + `/iapi/playlists/all`, {
    credentials: 'include',
  })
  return await result.json()
}

export async function list(limit = 15, page = 1, folderId = '') {
  const result = await fetch(
    config.API_URL + `/iapi/playlists?per_page=${limit}&page=${page}&folder=${folderId}`,
    { credentials: 'include' }
  )
  return await result.json()
}

export async function get(id) {
  const result = await fetch(config.API_URL + `/iapi/playlists/${id}`, {
    credentials: 'include',
  })
  return await result.json()
}

export async function update(id, body) {
  const res = await fetch(config.API_URL + `/iapi/playlists/${id}`, {
    method: 'PUT',
    headers: await getJsonHeaders(),
    credentials: 'include',
    body: JSON.stringify(body),
  })

  return {
    success: res.status === 200,
    data: await res.json(),
  }
}

export async function duplicate(id) {
  const res = await fetch(config.API_URL + `/iapi/playlists/duplicate/${id}`, {
    method: 'POST',
    headers: await getJsonHeaders(),
    credentials: 'include',
  })

  return {
    success: res.status === 201,
    data: await res.json(),
  }
}

export async function deletePlaylist(id) {
  const res = await fetch(config.API_URL + `/iapi/playlists/${id}`, {
    method: 'DELETE',
    headers: await getJsonHeaders(),
    credentials: 'include',
  })

  const data = res.status === 204 ? {} : await res.json()
  return {
    success: res.status === 204,
    data,
  }
}

export async function setFolder(body) {
  const res = await fetch(config.API_URL + `/iapi/playlists/set-folder`, {
    method: 'POST',
    headers: await getJsonHeaders(),
    credentials: 'include',
    body: JSON.stringify(body),
  })

  return res.status === 204
}

export async function deleteSlides(id, body) {
  const res = await fetch(config.API_URL + `/iapi/playlists/${id}/delete-slides`, {
    method: 'PUT',
    headers: await getJsonHeaders(),
    credentials: 'include',
    body: JSON.stringify(body),
  })

  return res.status === 204
}
